import { GET_SELLER_WALLET_PLANS_REQUEST, GET_SELLER_WALLET_PLANS_SUCCESS, GET_SELLER_WALLET_PLANS_FAILURE, GET_SELLER_WALLET_PLANS_RESET, } from "../../actions";
const initialState = {
    walletPlansData: [],
    loading: false,
    error: null,
};
const getSellerWalletPlansReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_SELLER_WALLET_PLANS_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, walletPlansData: action.payload });
        case GET_SELLER_WALLET_PLANS_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, walletPlansData: null, error: null });
        case GET_SELLER_WALLET_PLANS_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload, walletPlansData: null });
        case GET_SELLER_WALLET_PLANS_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, walletPlansData: null, error: null });
        default:
            return state;
    }
};
export default getSellerWalletPlansReducer;
